import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { useContext } from 'react';
import { useQuery } from 'react-query';
import { ace_api } from '@axo/shared/data-access/api';
import {
  notificationKeys,
  parseNotificationKey,
} from '../../cache-keys/notificationKeys';
import { queryFunction } from '../../query-function';

export function useRecentUnreadNotifications(marketCountry: string, n = 50) {
  const api = useAPI();

  const ctx = useContext(DataAccessContext);
  const clientID = ctx?.state?.user?.clientID ?? '';
  const token = ctx?.state?.user?.token ?? '';

  const cacheKey = notificationKeys.unread({
    user: clientID,
    country: marketCountry,
  });

  const notifications = useQuery(
    cacheKey,
    queryFunction(ace_api.getRecentNotifications(api), ({ queryKey }) => {
      const key = parseNotificationKey(queryKey);
      return {
        ClientID: key.user,
        MarketCountry: key.country,
        Read: false,
        Limit: n,
      };
    }),
    {
      enabled: token.length > 0 && marketCountry !== '',
    }
  );

  return notifications?.data ?? [];
}
